import React from 'react';
import PropTypes from 'prop-types';
import Story from './Story/Story';

const Stories = ({ stories, storyType }) =>
  stories.map((story, index) => {
    const image = story?.card_image ?? story?.feature_image;
    if (storyType === 'publications') {
      return (
        <Story
          index={index}
          key={`more-story-${story.slug}-${index}`}
          title={story?.title ?? ''}
          image={image}
          link={`/publications/${story?.issue?.issue_publication?.slug}/${story?.issue?.slug}/${story?.slug}`}
        />
      );
    } else if (storyType === 'news') {
      return (
        <Story
          index={index}
          key={`more-story-${story.slug}-${index}`}
          title={story?.title ?? ''}
          image={image}
          link={`/news/${story?.slug}`}
        />
      );
    } else if (storyType === 'projects') {
      return (
        <Story
          index={index}
          key={`more-story-${story.slug}-${index}`}
          title={story?.title ?? ''}
          image={image}
          link={`/projects/${story?.slug}`}
        />
      );
    } else if (storyType === 'posts') {
      return (
        <Story
          index={index}
          key={`more-story-${story.slug}-${index}`}
          title={story?.title ?? ''}
          image={image}
          link={`/posts/${story?.slug}`}
        />
      );
    }
  });

Stories.defaultProps = {
  stories: [],
  storyType: 'posts',
};

Stories.propTypes = {
  stories: PropTypes.array.isRequired,
  storyType: PropTypes.oneOf(['posts', 'publications', 'news', 'projects'])
    .isRequired,
};

export default Stories;
